import { render, staticRenderFns } from "./home_pay.vue?vue&type=template&id=2ec90fb4&scoped=true&"
import script from "./home_pay.vue?vue&type=script&lang=js&"
export * from "./home_pay.vue?vue&type=script&lang=js&"
import style0 from "./home_pay.vue?vue&type=style&index=0&id=2ec90fb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec90fb4",
  null
  
)

export default component.exports